import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import "./index.css";
import App from "./App";
import AppAltlINE from "./AltLine/src/App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/Store/store";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { PersistGate } from "redux-persist/integration/react";
import { SnackbarProvider } from "notistack";
import { SnackbarProvider as CustomSnackbarProvider } from "./components/SnackbarContext";

import { createRoot } from "react-dom/client";
import { AltStore, Altpersistor } from  "./AltLine/src/redux/Store/store"    //"./redux/Store/store";

const container = document.getElementById("root");
const root = createRoot(container);

const websiteName = localStorage.getItem("WEBSITE");
// if (!websiteName) {
//   localStorage.setItem("WEBSITE", "P2P");
// }

root.render(
  <React.StrictMode>
    {websiteName === "P2P" ? (
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <CustomSnackbarProvider>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <GoogleOAuthProvider clientId="873652672045-vmi4hk4r35klcths3idmm5r2nq1idis0.apps.googleusercontent.com">
                <App />
              </GoogleOAuthProvider>
            </PersistGate>
          </Provider>
        </CustomSnackbarProvider>
      </SnackbarProvider>
    ) : (
      <Provider store={AltStore}>
        <PersistGate loading={null} persistor={Altpersistor}>
          <React.StrictMode>
            <GoogleOAuthProvider clientId="873652672045-vmi4hk4r35klcths3idmm5r2nq1idis0.apps.googleusercontent.com">
              <AppAltlINE />
            </GoogleOAuthProvider>
          </React.StrictMode>
        </PersistGate>
      </Provider>
    )}
  </React.StrictMode>
  // ,
  // document.getElementById("root")
);
serviceWorkerRegistration.register();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
